import AjaxBuilder from "../../Common/AjaxBuilder";
import { Category } from "./Components/Calculator/Category";
import { City } from "./Components/Calculator/City";
import { Franchise } from "./Components/Calculator/Franchise";
import { CalculateInsurance } from "./Components/Calculator/CalculateInsurance";
import { ContinueBtn } from "./Components/Calculator/ContinueBtn";
import { AlertMessage } from "../CommonComponents/Insurance/AlertMessage";
import { Loader } from "../CommonComponents/Insurance/Loader";

export class OsagoCalculator {
    constructor() {
        this.$insuranceForm = $('#insurance_app .calculator_form');

        this._state = {
            category: null,
            city: null,
            franchise: null,
            brand: null,
            model: null,
            price: 0,
            tariff: null,
        };

        this._init();
    }

    _init() {
        this._calculateInsurance = new CalculateInsurance({
            insuranceForm: this.$insuranceForm,
            state: this._state
        });

        this._categories = new Category({
            insuranceForm: this.$insuranceForm,
            state: this._state,
            calculateInsurance: this._calculateInsurance,
        });

        this._city = new City({
            insuranceForm: this.$insuranceForm,
            state: this._state,
            calculateInsurance: this._calculateInsurance,
        });

        this._franchise = new Franchise({
            insuranceForm: this.$insuranceForm,
            state: this._state,
            calculateInsurance: this._calculateInsurance,
        });

        this._continueBtn = new ContinueBtn({
            insuranceForm: this.$insuranceForm,
            state: this._state,
        });

        this._getActualData();
    }

    _getActualData() {
        Loader.showLoader(this.$insuranceForm);
        new AjaxBuilder({
            route: $(this.$insuranceForm).data('get-info'),
        }, 'GET').execute({
            success: this._getActualDataSuccess.bind(this),
            error: this._getActualDataError.bind(this),
        });
    }

    _getActualDataSuccess(data) {
        this._categories.init(data.response.categories);
        this._city.init(data.response.cities);
        this._franchise.init(data.response.franchises);

        Loader.hideLoader(this.$insuranceForm);
    }

    _getActualDataError(data) {
        console.log('Error: ', data);
        AlertMessage.showMessage(data.responseJSON.errors);
        Loader.hideLoader(this.$insuranceForm);
    }
}

$(() => {
    new OsagoCalculator();
});
